import React, { useState } from 'react';
import { useTradingViewChart } from '../../../hooks/useTradingViewChart';
import { ExternalLink } from 'lucide-react';
import { openCoinMarketCap } from '../../../utils/coinMarketUtils';

const PriceChart = ({ coin }) => {
  const [selectedTimeframe, setSelectedTimeframe] = useState("1M");
  const { chartContainerRef } = useTradingViewChart(coin, selectedTimeframe);

  const timeframes = ["1D", "1W", "1M", "1Y"];

  return (
    <div className="card">
      <div className="mb-2 d-flex gap-2 justify-end p-3">
        {timeframes.map(tf => (
          <button
            key={tf}
            className={`modal-button p-2 h-auto flex-none ${selectedTimeframe === tf ? "primary" : "secondary"}`}
            style={{minHeight: 'auto'}}
            onClick={() => setSelectedTimeframe(tf)}
          >
            {tf}
          </button>
        ))}
      </div>

      <div ref={chartContainerRef} style={{ height: 300 }} />

      <div className="p-3 d-flex justify-content-end border-top">
        <button
          className="underline flex gap-2 justify-center text-secondary hover:text-primary transition-colors"
          onClick={() => openCoinMarketCap(coin)}
          style={{ border: 'none', background: 'none', fontSize: '0.9rem', minHeight: 'auto' }}
        >
          <ExternalLink size={16} /> View on CoinMarketCap
        </button>
      </div>
    </div>
  );
};

export default PriceChart;